module.exports = __webpack_public_path__ + "static/media/suraj_sonawane.493716e3.png";